// @flow

import * as React from 'react';

import { type DateLike } from 'app/lib/date';
import JobLogGroupStore from 'app/stores/JobLogGroupStore';

import JobLogOutputHeader from './Header';
import JobLogOutputLine from './Line';

const getStateFromStores = (id) => ({ expanded: JobLogGroupStore.isExpanded(id) });

type Props = {
  id: string,
  name: ?string,
  lines: Array<{
    id: string,
    number: number,
    line: string,
    startedAt: ?DateLike
  }>,
  number: number,
  startedAt: ?DateLike,
  finishedAt: ?DateLike,
  durationPercentage: ?number,
  bootstrap?: boolean,
  timestampsOn: ?boolean,
  timestampsInUTC: ?boolean,
  onTimestampClick: ?(SyntheticMouseEvent<HTMLElement>) => void
};

type State = {
  expanded: boolean
};

export default class JobLogOutputGroup extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = getStateFromStores(props.id);
  }

  componentDidMount() {
    JobLogGroupStore.addChangeListener(this.props.id, this.handleStoreChange);
  }

  componentWillUnmount() {
    JobLogGroupStore.removeChangeListener(this.props.id, this.handleStoreChange);
  }

  handleStoreChange = () => {
    this.setState(getStateFromStores(this.props.id));
  };

  handleTimestampClick = (evt: SyntheticMouseEvent<HTMLElement>) => {
    if (this.props.onTimestampClick) {
      this.props.onTimestampClick(evt);
    }
  };

  constructLineNodes(): Array<React.Element<any>> {
    return this.props.lines.map((line) => (
      <JobLogOutputLine key={line.id} timestampsOn={this.props.timestampsOn} timestampsInUTC={this.props.timestampsInUTC} onTimestampClick={this.handleTimestampClick} {...line} />
    ));
  }

  render() {
    // If we have a name, then show it as a collapsable group, otherwise just
    // dump all the lines in there.
    if (this.props.name) {
      const { name, lines: _lines, ...remainder } = this.props;

      return (
        <tbody>
          <JobLogOutputHeader
            {...remainder}
            timestampsOn={this.props.timestampsOn}
            onTimestampClick={this.handleTimestampClick}
            name={name}
          />
          {this.state.expanded && this.constructLineNodes()}
        </tbody>
      );
    }

    return (
      <tbody>
        {this.constructLineNodes()}
      </tbody>
    );
  }
}
